import React, { createContext, useReducer } from "react";
import { act } from "react-dom/test-utils";
import { defaultFBI } from "../config";
import {
  setFieldId,
  setLocation,
  setFeature,
  setZoom,
  setFBILevel,
  setIndex,
  setUploadFeature,
  setYear,
  setTable,
  setCropYear,
  setSeason,
} from "./actions";

import { indexName, table } from "../config";

const initialState = {
  mode: "",
  dataLayer: "delineatedFields",
  location: {
    center: [37.8897, -2.1632],
    zoom: 10.15,
    name: "Makueni County, Kenya",
    country_code: "ke",
  },
  fbiLevel: defaultFBI && defaultFBI === "world" ? defaultFBI : "local",
  features: [],
  indexName: indexName,
  uploadFeature: {},
  year: 2024,
  table: table,
  cropYear: 2024,
  season: "summer",
};

const store = createContext(initialState);
const { Provider } = store;

const StateProvider = ({ children }) => {
  const [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case setFieldId:
        return {
          ...state,
          fieldId: action.payload.fieldId,
        };
      case setLocation:
        return {
          ...state,
          feature: undefined,
          location: action.payload.location,
        };
      case setFeature:
        return {
          ...state,
          feature: action.payload.feature,
        };
      case setZoom:
        return {
          ...state,
          zoom: action.payload.zoom,
        };
      case setFBILevel:
        return {
          ...state,
          fbiLevel: action.payload.fbiLevel,
        };
      case setIndex:
        return {
          ...state,
          indexName: action.payload.indexName,
        };
      case setUploadFeature:
        return {
          ...state,
          uploadFeature: action.payload.uploadFeature,
        };

      case setYear:
        return {
          ...state,
          year: action.payload.year,
        };
      case setTable:
        return {
          ...state,
          table: action.payload.table,
        };
      case setCropYear: {
        return {
          ...state,
          cropYear: action.payload.cropYear,
        };
      }
      case setSeason: {
        return {
          ...state,
          season: action.payload.season,
        };
      }
      // return {
      //   ...state,
      //   features:
      //     state.features.length === 0 && action.payload.features
      //       ? [action.payload.features]
      //       : state.features.length === 1 && action.payload.features
      //       ? [state.features[0], action.payload.features]
      //       : [state.features[0]],
      // };
      default:
        throw new Error();
    }
  }, initialState);

  return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

export { store, StateProvider };
